(() => {
  function init(root=document) {
    root.querySelectorAll('[data-product]').forEach(product => {
      const select=product.querySelector('[data-variant]'); if(!select || select.dataset.bound) return; select.dataset.bound='true';
const cover=product.querySelector('[data-coverage]');if(cover){cover.disabled=false;const form=product.querySelector('.product-form');form.addEventListener('submit',async event=>{if(!cover.checked)return;event.preventDefault();const button=product.querySelector('[data-add]'),error=product.querySelector('[data-coverage-error]');if(button.dataset.busy)return;button.dataset.busy='true';button.disabled=true;error.textContent='';const qty=Number(form.querySelector('[name="quantity"]').value),id=Number(select.value);try{const base=window.Shopify?.routes?.root||'/';const result=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:qty},{id:Number(cover.dataset.id),quantity:qty,parent_id:id}]})});const data=await result.json();if(!result.ok)throw new Error(data.description||'Could not add this set.');location.assign(base+'cart');}catch(e){error.textContent='Please check your cart before retrying. '+e.message;button.disabled=false;delete button.dataset.busy;}});}

      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0], available=option.dataset.available==='true', price=product.querySelector('[data-price]'), button=product.querySelector('[data-add]');
        price.replaceChildren(document.createTextNode(option.dataset.price+' '));
        if(option.dataset.compare){const s=document.createElement('s');s.textContent=option.dataset.compare;price.append(s);}
        button.disabled=!available; button.textContent=available?'Add to cart':'Sold out';
        product.querySelector('[data-stock]').textContent=available?'Available to order':'Currently unavailable';
        const quantity=product.querySelector('[name="quantity"]');quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';quantity.value=quantity.min;
        if(option.dataset.max) quantity.max=option.dataset.max; else quantity.removeAttribute('max');
        const sku=product.querySelector('[data-sku]'); if(sku){sku.textContent=option.dataset.sku||'';sku.closest('p').hidden=!option.dataset.sku;}
        const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
        const media=option.dataset.media && document.getElementById(option.dataset.media); if(media) media.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
      });
    });
  }
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-nav[open],.nav-item details[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus();});}});
  document.addEventListener('click',event=>{document.querySelectorAll('.mobile-nav[open],.nav-item details[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open');});});
  document.addEventListener('shopify:section:load',event=>init(event.target));init();
})();
document.addEventListener('DOMContentLoaded', function () {
  const qty = document.querySelector('[data-product] input[name="quantity"]');

  if (!qty || qty.closest('.qty-stepper')) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'qty-stepper';

  const minus = document.createElement('button');
  minus.type = 'button';
  minus.setAttribute('aria-label', 'Decrease quantity');
  minus.textContent = '−';

  const plus = document.createElement('button');
  plus.type = 'button';
  plus.setAttribute('aria-label', 'Increase quantity');
  plus.textContent = '+';

  qty.parentNode.insertBefore(wrapper, qty);
  wrapper.appendChild(minus);
  wrapper.appendChild(qty);
  wrapper.appendChild(plus);

  minus.addEventListener('click', function () {
    const min = parseInt(qty.min || '1', 10);
    const step = parseInt(qty.step || '1', 10);
    const current = parseInt(qty.value || min, 10);

    qty.value = Math.max(min, current - step);
    qty.dispatchEvent(new Event('change', { bubbles: true }));
  });

  plus.addEventListener('click', function () {
    const step = parseInt(qty.step || '1', 10);
    const max = qty.max ? parseInt(qty.max, 10) : null;
    const current = parseInt(qty.value || '1', 10);
    const next = current + step;

    qty.value = max ? Math.min(max, next) : next;
    qty.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
document.addEventListener('click', async function (e) {
  const buyNowBtn = e.target.closest('[data-buy-now]');
  if (!buyNowBtn) return;

  e.preventDefault();

  const form = buyNowBtn.closest('form[action*="/cart/add"]');
  if (!form) return;

  buyNowBtn.disabled = true;
  const originalText = buyNowBtn.textContent;
  buyNowBtn.textContent = 'Adding...';
const resetBuyNowButton = () => {
  buyNowBtn.disabled = false;
  buyNowBtn.textContent = originalText;
};
  try {
    const formData = new FormData(form);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error('Could not add product to cart.');
    }

    window.location.href = '/cart';
  } catch (error) {
    console.error(error);
    resetBuyNowButton();
    alert('Could not add the product. Please try again.');
  }
});
window.addEventListener('pageshow', function () {
  document.querySelectorAll('[data-buy-now]').forEach(function (button) {
    button.disabled = false;
    button.textContent = 'Buy Now';
  });
});
document.addEventListener('click', function (e) {
  const stickyBtn = e.target.closest('[data-sticky-buy]');
  if (!stickyBtn) return;

  const realBuyNow = document.querySelector('[data-buy-now]');
  if (!realBuyNow) return;

  realBuyNow.click();
});
/* Judge.me form label cleanup */
document.addEventListener('click', function (e) {
  if (
    e.target.closest('.jdgm-write-review-btn') ||
    e.target.closest('[class*="write-review"]')
  ) {
    setTimeout(function () {
      document
        .querySelectorAll('.jdgm-write-review-modal__field-label')
        .forEach(function (label) {
          if (label.textContent.includes('(Required)')) {
            label.textContent = label.textContent
              .replace(/\s*\(Required\)/gi, '')
              .trim();
          }
        });
    }, 500);
  }
});
/* SafeHive bottom accordions - final */
document.addEventListener('click', function (event) {
  const button = event.target.closest('.safehive-bottom-toggle');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const accordion = button.closest('.safehive-bottom-accordion');
  if (!accordion) return;

  const content = accordion.querySelector('.safehive-bottom-content');
  const icon = button.querySelector('.safehive-bottom-plus');
  if (!content) return;

  const opening = content.hasAttribute('hidden');

  if (opening) {
    content.removeAttribute('hidden');
    button.setAttribute('aria-expanded', 'true');
    if (icon) icon.textContent = '−';
  } else {
    content.setAttribute('hidden', '');
    button.setAttribute('aria-expanded', 'false');
    if (icon) icon.textContent = '+';
  }
});
/* SafeHive - Product page reviews only */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;
  const initializedSorts = new WeakSet();
  function setupSafeHiveProductReviews() {
    const widget = document.querySelector('.sh-product-reviews #judgeme_product_reviews');
    if (!widget) return;
    const sort = widget.querySelector('.jdgm-sort-dropdown');
    if (sort && !initializedSorts.has(sort)) {
      initializedSorts.add(sort);
      if (sort.value !== 'pictures_first') {
        sort.value = 'pictures_first';
        sort.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    const grid = widget.querySelector('.jdgm-masonry-grid__container');
    if (!grid) return;
    const items = Array.from(grid.children).filter(item => item.classList.contains('jdgm-masonry-grid__masonry-item'));
    if (!items.length) return;
    grid.classList.add('sh-limited-reviews');
    items.forEach(function (item, index) {
      item.hidden = index >= 5;
      const content = item.querySelector('.jdgm-review-card__content');
      if (content) content.style.removeProperty('display');
    });
    let button = widget.querySelector('.safehive-see-all-reviews');
    if (!button) {
      button = document.createElement('a');
      button.className = 'safehive-see-all-reviews';
      button.href = '/pages/customer-reviews-safehive-pakistan';
      button.textContent = 'See All Customer Reviews →';
    }
    const container = grid.closest('.jdgm-masonry-grid');
    if (container && container.nextElementSibling !== button) container.insertAdjacentElement('afterend', button);
  }
  setupSafeHiveProductReviews();
  const observer = new MutationObserver(setupSafeHiveProductReviews);
  observer.observe(document.body, {childList:true,subtree:true});
})();

/* Default the full customer reviews page to photo reviews first. */
(function () {
  if (location.pathname.replace(/\/$/, '') !== '/pages/customer-reviews-safehive-pakistan') return;
  const initialized = new WeakSet();
  function applyPhotoSort() {
    document.querySelectorAll('.jdgm-sort-dropdown').forEach(function (sort) {
      if (initialized.has(sort)) return;
      if (!Array.from(sort.options).some(option => option.value === 'pictures_first')) return;
      initialized.add(sort);
      if (sort.value !== 'pictures_first') {
        sort.value = 'pictures_first';
        sort.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }
  applyPhotoSort();
  new MutationObserver(applyPhotoSort).observe(document.body, {childList:true, subtree:true});
})();
